import { BaseComponent } from "../../../react-core/Html/BaseComponent";

import * as React from "react";

import { TimerThatWorksInInactiveTabs } from "../../../react-core/Html/Components/Timer/TimerThatWorksInInactiveTabs";
import TimeoutContent from "./Resources/TimeoutContent";
import { Lightbox } from "../../../react-core/Html/Components/Lightbox";
import { Button } from "../../../react-core/Html/Button";

export interface ITimeoutWillExpireLightboxProps extends React.Props<TimeoutWillExpireLightbox> {
    secondsLeft: number;
    secondsToShowMessageAheadOfLogout: number;
    show: boolean;

    onLogout: () => void;

    onKeepSignedIn: () => void;
    onTimerExpired: () => void;
}

export interface ITimeoutWillExpireLightboxState {}

export class TimeoutWillExpireLightbox extends BaseComponent<
    ITimeoutWillExpireLightboxProps,
    ITimeoutWillExpireLightboxState
> {
    constructor(props: ITimeoutWillExpireLightboxProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        // TODO resources
        return (
            this.props.show && (
                <Lightbox
                    cssWrapper="is-default-lightbox is-countdown-lightbox"
                    unclosable={true}
                    show={this.props.show}
                    onClose={() => this.props.onLogout()}
                    title="Session time out"
                >
                    <div className="session-logout-sticky-alert" role="alert">
                        <div className="session-logout">
                            <h2 className="mb-0">Session time out</h2>
                            <TimerThatWorksInInactiveTabs
                                secondsToShowMessageAheadOfLogout={this.props.secondsLeft}
                                radius={56}
                                strokeWidth={8}
                                propsSecondsLeft={this.props.secondsLeft}
                                onTimerExpire={() => this.props.onTimerExpired()}
                                cssWrapper="vspace-20"
                            />

                            <p className="pb-26">
                                You haven't used your session for a while.
                                <br />
                                For security we will log you out.
                            </p>
                            <div className="row">
                                <div className="col-fluid col-left">
                                    <Button onClick={() => this.props.onLogout()} className="btn secondary block-xxs">
                                        {TimeoutContent.Button_logout}
                                    </Button>
                                </div>
                                <div className="col-right">
                                    <Button
                                        onClick={() => this.props.onKeepSignedIn()}
                                        className="btn primary block-xxs"
                                    >
                                        {TimeoutContent.Button_keep_logged}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Lightbox>
            )
        );
    }
}
